module.exports = __webpack_public_path__ + "static/img/nodeMCU_1.0-1.f5d9bad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/nodeMCU_1.0-1.svg
// module id = sPzl
// module chunks = 0